// extracted by mini-css-extract-plugin
export default {"dropzoneWrapper":"PictureDropzone_dropzoneWrapper__IF3t0","label":"PictureDropzone_label__Bkd5Z","closeButton":"PictureDropzone_closeButton__RsJgX"};